import axios from '@/jslib/axios'

export const sendAppointee = data => {
  return axios({
    method: 'post',
    url: '/admin/appointee/send',
    data
  })
}
